<script setup lang="ts">
import { useRegisterSW } from "virtual:pwa-register/vue";
import { computed, onMounted, watch } from "vue";
import { registerSW } from "virtual:pwa-register";
import router from "@/router/router";

const { offlineReady, needRefresh, updateServiceWorker } = useRegisterSW();

async function close() {
	offlineReady.value = false;
	needRefresh.value = false;
}

onMounted(() => {
	const intervalMS = 5 * 60 * 1000;

	const updateSW = registerSW({
		onRegisteredSW(swUrl, r) {
			r &&
				setInterval(async () => {
					if (!(!r.installing && navigator)) return;

					if ("connection" in navigator && !navigator.onLine) return;

					const resp = await fetch(swUrl, {
						cache: "no-store",
						headers: {
							cache: "no-store",
							"cache-control": "no-cache",
						},
					});

					if (resp?.status === 200) await r.update();
				}, intervalMS);
		},
	});
});

const update = () => {
	updateServiceWorker(true);
};

const showDialog = computed(
	() =>
		needRefresh.value && router.currentRoute.value.name !== "render-dashboard"
);
</script>

<template>
	<div v-if="showDialog" class="pwa-toast">
		<v-card elevation="1" max-width="450">
			<v-toolbar style="border-radius: 0 !important" color="white" flat>
				<v-toolbar-title
					><i class="fa-light fa-party-horn fa-xl mr-3"></i>
					New Version!
				</v-toolbar-title>
				<v-spacer></v-spacer>

				<v-btn icon @click="close">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-divider />
			<div class="px-5 py-3">
				A new version is available. It may include bug fixes, performance
				improvements, and/or new features. Click ‘Reload’ to update.
			</div>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn variant="text" color="error" @click="close">Close</v-btn>
				<v-btn variant="tonal" color="teal" @click="update">Reload</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<style>
.pwa-toast {
	position: fixed;
	right: 0;
	bottom: 80px;
	margin: 16px;
	padding: 12px;
	z-index: 1;
}
</style>
